export default __webpack_public_path__ + "static/media/kitchen2-480w.85ee7c47.webp";